// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaleLoanIllustration_LoanValueHistoryFragment = { __typename?: 'EstateWaterfallLoanValueHistory', year: number, beginningOfYearValue?: CurrencyUSD | null, endOfYearValue?: CurrencyUSD | null, interestPaid?: CurrencyUSD | null, principalPaid?: CurrencyUSD | null };

export type SaleLoanIllustration_NodeValueHistoryFragment = { __typename?: 'EstateWaterfallNodeValueHistory', year: number, assetGrowth?: CurrencyUSD | null, beginningOfYearValue?: CurrencyUSD | null, endOfYearValue?: CurrencyUSD | null };

export type SaleLoanIllustration_EstateWaterfallVizNodeFragment = { __typename?: 'EstateWaterfallVizNode', id: string, _cacheKey: string, afterDeath: Types.AfterDeath, waterfallID: string, value: CurrencyUSD, valueBeforeDispositions?: CurrencyUSD | null, transferredToEstateTax?: CurrencyUSD | null, transferredToGiftingTax?: CurrencyUSD | null, valueBeforePouroverWills?: CurrencyUSD | null, taxableValue?: CurrencyUSD | null, nonTaxableValue?: CurrencyUSD | null, inEstateStatus: Types.EntityInEstateStatus };

export type SaleLoanIllustration_TaxSummaryV2Fragment = { __typename?: 'TaxSummaryV2', _cacheKey: string, federalTax?: { __typename?: 'FederalTaxDetail', _cacheKey: string, tax: CurrencyUSD } | null, stateTax?: Array<{ __typename?: 'StateTaxDetail', _cacheKey: string, tax: CurrencyUSD }> | null, gstTax?: { __typename?: 'GSTTaxDetail', _cacheKey: string, tax: CurrencyUSD } | null };

export type SaleLoanIllustration_GiftTaxSummaryFragment = { __typename?: 'GiftTaxSummary', _cacheKey: string, federalGiftTax?: { __typename?: 'GiftTaxDetail', _cacheKey: string, tax: CurrencyUSD } | null, gstGiftTax?: { __typename?: 'GiftTaxDetail', _cacheKey: string, tax: CurrencyUSD } | null, stateGiftTax?: Array<{ __typename?: 'StateGiftTaxDetail', _cacheKey: string, tax: CurrencyUSD }> | null };

export type SaleLoanIllustration_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, visualizationWithSaleLoanProjections: { __typename?: 'EstateWaterfallViz', _cacheKey: string, materializedInputParams: { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null }, beforeFirstDeathTaxSummaryV2?: (
      { __typename?: 'GiftTaxSummary' }
      & SaleLoanIllustration_GiftTaxSummaryFragment
    ) | null, firstDeathTaxSummaryV2: (
      { __typename?: 'TaxSummaryV2' }
      & SaleLoanIllustration_TaxSummaryV2Fragment
    ), secondDeathTaxSummaryV2?: (
      { __typename?: 'TaxSummaryV2' }
      & SaleLoanIllustration_TaxSummaryV2Fragment
    ) | null, loans: Array<{ __typename?: 'EstateWaterfallLoan', id?: string | null, pseudoID?: string | null, valueHistory: Array<(
        { __typename?: 'EstateWaterfallLoanValueHistory' }
        & SaleLoanIllustration_LoanValueHistoryFragment
      )> }>, nodes: Array<(
      { __typename?: 'EstateWaterfallVizNode', valueHistory: Array<(
        { __typename?: 'EstateWaterfallNodeValueHistory' }
        & SaleLoanIllustration_NodeValueHistoryFragment
      )> }
      & SaleLoanIllustration_EstateWaterfallVizNodeFragment
    )> }, visualizationWithoutSaleLoanProjections: { __typename?: 'EstateWaterfallViz', _cacheKey: string, materializedInputParams: { __typename?: 'EstateWaterfallMaterializedInputParams', firstGrantorDeathYear: number, secondGrantorDeathYear?: number | null, selectedGrowthProfile?: { __typename?: 'GrowthProfile', id: string, displayName: string } | null }, beforeFirstDeathTaxSummaryV2?: (
      { __typename?: 'GiftTaxSummary' }
      & SaleLoanIllustration_GiftTaxSummaryFragment
    ) | null, firstDeathTaxSummaryV2: (
      { __typename?: 'TaxSummaryV2' }
      & SaleLoanIllustration_TaxSummaryV2Fragment
    ), secondDeathTaxSummaryV2?: (
      { __typename?: 'TaxSummaryV2' }
      & SaleLoanIllustration_TaxSummaryV2Fragment
    ) | null, nodes: Array<(
      { __typename?: 'EstateWaterfallVizNode' }
      & SaleLoanIllustration_EstateWaterfallVizNodeFragment
    )> } };

export type SaleLoanEstateWaterfallQueryVariables = Types.Exact<{
  waterfallId: Types.Scalars['ID']['input'];
  projectionInput?: Types.InputMaybe<Types.EstateWaterfallProjectionInput>;
  noSaleLoanProjectionInput?: Types.InputMaybe<Types.EstateWaterfallProjectionInput>;
}>;


export type SaleLoanEstateWaterfallQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & SaleLoanIllustration_EstateWaterfallFragment
      ) | null } | null> | null } };

export type SaleLoanIllustration_GrowthProfileFragment = { __typename?: 'GrowthProfile', id: string, displayName: string };

export type GrowthProfileOptionsQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type GrowthProfileOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, growthProfiles: { __typename?: 'GrowthProfileConnection', edges?: Array<{ __typename?: 'GrowthProfileEdge', node?: (
              { __typename?: 'GrowthProfile' }
              & SaleLoanIllustration_GrowthProfileFragment
            ) | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    SaleLoanEstateWaterfall: 'SaleLoanEstateWaterfall' as const,
    GrowthProfileOptions: 'GrowthProfileOptions' as const
  },
  Fragment: {
    SaleLoanIllustration_LoanValueHistory: 'SaleLoanIllustration_LoanValueHistory' as const,
    SaleLoanIllustration_NodeValueHistory: 'SaleLoanIllustration_NodeValueHistory' as const,
    SaleLoanIllustration_EstateWaterfallVizNode: 'SaleLoanIllustration_EstateWaterfallVizNode' as const,
    SaleLoanIllustration_TaxSummaryV2: 'SaleLoanIllustration_TaxSummaryV2' as const,
    SaleLoanIllustration_GiftTaxSummary: 'SaleLoanIllustration_GiftTaxSummary' as const,
    SaleLoanIllustration_EstateWaterfall: 'SaleLoanIllustration_EstateWaterfall' as const,
    SaleLoanIllustration_GrowthProfile: 'SaleLoanIllustration_GrowthProfile' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const SaleLoanIllustration_GiftTaxSummaryFragmentDoc = gql`
    fragment SaleLoanIllustration_GiftTaxSummary on GiftTaxSummary {
  _cacheKey
  federalGiftTax {
    _cacheKey
    tax
  }
  gstGiftTax {
    _cacheKey
    tax
  }
  stateGiftTax {
    _cacheKey
    tax
  }
}
    `;
export const SaleLoanIllustration_TaxSummaryV2FragmentDoc = gql`
    fragment SaleLoanIllustration_TaxSummaryV2 on TaxSummaryV2 {
  _cacheKey
  federalTax {
    _cacheKey
    tax
  }
  stateTax {
    _cacheKey
    tax
  }
  gstTax {
    _cacheKey
    tax
  }
}
    `;
export const SaleLoanIllustration_LoanValueHistoryFragmentDoc = gql`
    fragment SaleLoanIllustration_LoanValueHistory on EstateWaterfallLoanValueHistory {
  year
  beginningOfYearValue
  endOfYearValue
  interestPaid
  principalPaid
}
    `;
export const SaleLoanIllustration_EstateWaterfallVizNodeFragmentDoc = gql`
    fragment SaleLoanIllustration_EstateWaterfallVizNode on EstateWaterfallVizNode {
  id
  _cacheKey
  afterDeath
  waterfallID
  value
  valueBeforeDispositions
  transferredToEstateTax
  transferredToGiftingTax
  valueBeforePouroverWills
  taxableValue
  nonTaxableValue
  inEstateStatus
}
    `;
export const SaleLoanIllustration_NodeValueHistoryFragmentDoc = gql`
    fragment SaleLoanIllustration_NodeValueHistory on EstateWaterfallNodeValueHistory {
  year
  assetGrowth
  beginningOfYearValue
  endOfYearValue
}
    `;
export const SaleLoanIllustration_EstateWaterfallFragmentDoc = gql`
    fragment SaleLoanIllustration_EstateWaterfall on EstateWaterfall {
  id
  displayName
  visualizationWithSaleLoanProjections: visualizationWithProjections(
    input: $projectionInput
  ) {
    _cacheKey
    materializedInputParams {
      firstGrantorDeathYear
      secondGrantorDeathYear
      selectedGrowthProfile {
        id
        displayName
      }
    }
    beforeFirstDeathTaxSummaryV2 {
      ...SaleLoanIllustration_GiftTaxSummary
    }
    firstDeathTaxSummaryV2 {
      ...SaleLoanIllustration_TaxSummaryV2
    }
    secondDeathTaxSummaryV2 {
      ...SaleLoanIllustration_TaxSummaryV2
    }
    loans {
      id
      pseudoID
      valueHistory {
        ...SaleLoanIllustration_LoanValueHistory
      }
    }
    nodes {
      ...SaleLoanIllustration_EstateWaterfallVizNode
      valueHistory {
        ...SaleLoanIllustration_NodeValueHistory
      }
    }
  }
  visualizationWithoutSaleLoanProjections: visualizationWithProjections(
    input: $noSaleLoanProjectionInput
  ) {
    _cacheKey
    materializedInputParams {
      firstGrantorDeathYear
      secondGrantorDeathYear
      selectedGrowthProfile {
        id
        displayName
      }
    }
    beforeFirstDeathTaxSummaryV2 {
      ...SaleLoanIllustration_GiftTaxSummary
    }
    firstDeathTaxSummaryV2 {
      ...SaleLoanIllustration_TaxSummaryV2
    }
    secondDeathTaxSummaryV2 {
      ...SaleLoanIllustration_TaxSummaryV2
    }
    nodes {
      ...SaleLoanIllustration_EstateWaterfallVizNode
    }
  }
}
    ${SaleLoanIllustration_GiftTaxSummaryFragmentDoc}
${SaleLoanIllustration_TaxSummaryV2FragmentDoc}
${SaleLoanIllustration_LoanValueHistoryFragmentDoc}
${SaleLoanIllustration_EstateWaterfallVizNodeFragmentDoc}
${SaleLoanIllustration_NodeValueHistoryFragmentDoc}`;
export const SaleLoanIllustration_GrowthProfileFragmentDoc = gql`
    fragment SaleLoanIllustration_GrowthProfile on GrowthProfile {
  id
  displayName
}
    `;
export const SaleLoanEstateWaterfallDocument = gql`
    query SaleLoanEstateWaterfall($waterfallId: ID!, $projectionInput: EstateWaterfallProjectionInput, $noSaleLoanProjectionInput: EstateWaterfallProjectionInput) {
  estateWaterfalls(where: {id: $waterfallId}) {
    edges {
      node {
        ...SaleLoanIllustration_EstateWaterfall
      }
    }
  }
}
    ${SaleLoanIllustration_EstateWaterfallFragmentDoc}`;

/**
 * __useSaleLoanEstateWaterfallQuery__
 *
 * To run a query within a React component, call `useSaleLoanEstateWaterfallQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleLoanEstateWaterfallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleLoanEstateWaterfallQuery({
 *   variables: {
 *      waterfallId: // value for 'waterfallId'
 *      projectionInput: // value for 'projectionInput'
 *      noSaleLoanProjectionInput: // value for 'noSaleLoanProjectionInput'
 *   },
 * });
 */
export function useSaleLoanEstateWaterfallQuery(baseOptions: Apollo.QueryHookOptions<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>(SaleLoanEstateWaterfallDocument, withFetchPolicyContext(options));
      }
export function useSaleLoanEstateWaterfallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>(SaleLoanEstateWaterfallDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useSaleLoanEstateWaterfallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>(SaleLoanEstateWaterfallDocument, withFetchPolicyContext(options));
        }
export type SaleLoanEstateWaterfallQueryHookResult = ReturnType<typeof useSaleLoanEstateWaterfallQuery>;
export type SaleLoanEstateWaterfallLazyQueryHookResult = ReturnType<typeof useSaleLoanEstateWaterfallLazyQuery>;
export type SaleLoanEstateWaterfallSuspenseQueryHookResult = ReturnType<typeof useSaleLoanEstateWaterfallSuspenseQuery>;
export type SaleLoanEstateWaterfallQueryResult = Apollo.QueryResult<SaleLoanEstateWaterfallQuery, SaleLoanEstateWaterfallQueryVariables>;
export const GrowthProfileOptionsDocument = gql`
    query GrowthProfileOptions($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        growthProfiles {
          edges {
            node {
              ...SaleLoanIllustration_GrowthProfile
            }
          }
        }
      }
    }
  }
}
    ${SaleLoanIllustration_GrowthProfileFragmentDoc}`;

/**
 * __useGrowthProfileOptionsQuery__
 *
 * To run a query within a React component, call `useGrowthProfileOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGrowthProfileOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGrowthProfileOptionsQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useGrowthProfileOptionsQuery(baseOptions: Apollo.QueryHookOptions<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>(GrowthProfileOptionsDocument, withFetchPolicyContext(options));
      }
export function useGrowthProfileOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>(GrowthProfileOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGrowthProfileOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>(GrowthProfileOptionsDocument, withFetchPolicyContext(options));
        }
export type GrowthProfileOptionsQueryHookResult = ReturnType<typeof useGrowthProfileOptionsQuery>;
export type GrowthProfileOptionsLazyQueryHookResult = ReturnType<typeof useGrowthProfileOptionsLazyQuery>;
export type GrowthProfileOptionsSuspenseQueryHookResult = ReturnType<typeof useGrowthProfileOptionsSuspenseQuery>;
export type GrowthProfileOptionsQueryResult = Apollo.QueryResult<GrowthProfileOptionsQuery, GrowthProfileOptionsQueryVariables>;